/* eslint-disable no-console */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from 'app/app.module';

import './app/core/extensions/route-active.extensions';
import { environment } from 'environments/environment';
import { initFortface } from '@mottu-ops/face-liveness';

if (environment.state.production) enableProdMode();

initFortface();

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));
